export class ToastSeverity {
  public static Success: string = 'success';
  public static Info: string = 'info';
  public static Warning: string = 'warn';
  public static Error: string = 'error';
}
